"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAfterSubstring = void 0;
const getAfterSubstring = (str, substring) => {
  const index = str.indexOf(substring);
  return index !== -1 ? str.slice(index + substring.length) : '';
};
exports.getAfterSubstring = getAfterSubstring;